module.exports = __webpack_public_path__ + "img/julianinsta.b06cab66.jpg";